import { array, boolean, InferType, number, object, string } from "yup";
import { RegistrarAccountSchema } from "./RegistrarAccount";

export const PBNSchema = object({
    id: number().required(),
    name: string().required().max(50, "error.pbn.name.max"),
    isPrivate: boolean().default(false),
    allowedCountries: array().of(string()).notRequired(),
    imageAi: boolean().default(null).nullable(),
    categoryAi: boolean().default(null).nullable(),
    reviewAi: boolean().default(null).nullable(),
    serverIp: string().when("isPrivate", {
        is: (isPrivate: boolean) => isPrivate,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
    }),
    hasGTMetrix: boolean().default(false),
    intentSearch: boolean().default(false),
    internalLinking: boolean().default(false),
    imageInBody: boolean().default(false),
    youtubeInBody: boolean().default(false),
    humanise: boolean().default(false),
    contactGroupId: number().notRequired(),
    allowedIps: array().of(string()).notRequired(),
    postByDefault: number().notRequired(),
    pbnT1: array().of(number().required()).nullable(),
    pbnT2: array().of(number().required()).nullable(),
    cloudflareApiKey: string().notRequired(),
    cloudflareApiSecret: string().notRequired(),
    registrarAccount: array().of(RegistrarAccountSchema),
    forLinking: boolean(),
    gptOption: string().when("isPrivate", {
        is: (isPrivate: boolean) => isPrivate,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
    }),
});

export type PBN = InferType<typeof PBNSchema>;

export const PBNDtoSchema = PBNSchema.omit([
    "id",
    "registrarAccount",
    "pbnT1",
    "pbnT2",
    "categoryAi",
    "reviewAi",
]).concat(
    object({
        categoryAi: string<TPBNAiTag>().default("nobody").nullable(),
        reviewAi: string<TPBNAiTag>().default("nobody").nullable(),
        registrarIds: array().of(string()).notRequired(),

        pbnT1: array()
            .of(string().required())
            .when("isPrivate", {
                is: (isPrivate: boolean) => isPrivate,
                then: (schema) => schema.required(),
                otherwise: (schema) => schema.notRequired(),
            }),
        pbnT2: array()
            .of(string().required())
            .when("isPrivate", {
                is: (isPrivate: boolean) => isPrivate,
                then: (schema) => schema.required(),
                otherwise: (schema) => schema.notRequired(),
            }),
    })
);
export type PBNDto = InferType<typeof PBNDtoSchema>;

export type TPBNAiTag = "nobody" | "human" | "ai";
export const pbnAiConvertToBool = (tag?: TPBNAiTag | null): boolean | null => {
    switch (tag) {
        case "ai":
            return true;
        case "nobody":
        case null:
        case undefined:
            return null;
        case "human":
            return false;
    }
};
export const pbnAiConvertToString = (tag?: boolean | null): TPBNAiTag | null => {
    switch (tag) {
        case true:
            return "ai";
        case false:
            return "human";
        case null:
        case undefined:
            return "nobody";
    }
};
